(() => {
  const setHeadingLines = (heading, lines, className) => {
    if (!heading) return;

    heading.classList.add(className);
    heading.replaceChildren();

    lines.forEach((line) => {
      const span = document.createElement('span');
      span.textContent = line;
      heading.appendChild(span);
    });
  };

  const applyPerfectTimingTypography = () => {
    const heroHeading = document.querySelector('[id^="PerfectTimingHero-"]');
    setHeadingLines(heroHeading, ['Stop Guessing', 'How to Train', 'for the 40'], 'pt-hero-title');

    const programHeading = document.querySelector('[id^="PerfectTimingPrograms-"]');

    if (programHeading) {
      const intro = programHeading.closest('.pt-section__intro');
      if (intro) intro.classList.add('pt-program-intro');
    }

    setHeadingLines(programHeading, ['Three Programs.', 'One Clear Progression.'], 'pt-program-title');
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyPerfectTimingTypography, { once: true });
  } else {
    applyPerfectTimingTypography();
  }

  document.addEventListener('shopify:section:load', applyPerfectTimingTypography);
})();
